var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "place"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C6.1 0 3 3.1 3 7C3 12.2 10 20 10 20C10 20 17 12.2 17 7C17 3.1 13.9 0 10 0ZM10 9.5C8.6 9.5 7.5 8.4 7.5 7C7.5 5.6 8.6 4.5 10 4.5C11.4 4.5 12.5 5.6 12.5 7C12.5 8.4 11.4 9.5 10 9.5Z",
    fill: "#00A3FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map_icon.67af0b0e2d516ea3f92db7eec0341c94.svg";
export { ForwardRef as ReactComponent };